<template>
  <div id="m_header_topbar" class="m-topbar  m-stack m-stack--ver m-stack--general m-stack--fluid">
    <div class="m-stack__item m-topbar__nav-wrapper">

      <ul class="m-topbar__nav m-nav m-nav--inline">
        <!-- begin: usermenu -->
        <li
          class="m-nav__item m-topbar__user-profile m-topbar__user-profile--img  m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light"
          :m-dropdown-toggle="'click'"
          id="userProfileMenu">
          <a href="javascript:" class="m-nav__link m-dropdown__toggle" id="userProfileMenuLink">
            <span class="m-topbar__userpic">
               <span class="m-type m--bg-brand">
                    <span class="m--font-light">{{ firstLetter }}</span>
               </span>
            </span>
            <span class="m-topbar__username m--hide">Nick</span>
          </a>
          <div class="m-dropdown__wrapper">
            <span class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"></span>
            <div class="m-dropdown__inner">
              <div class="m-dropdown__header m--align-center"
                   :style="'background-image: url('+cdn_url+'/img/misc/user_profile_bg_blue.jpg); background-size: cover;'">
                <div class="m-card-user m-card-user--skin-dark">
                  <div class="m-card-user__pic">
                    <span class="m-type m--bg-light">
                        <span class="m--font-brand">{{ firstLetter }}</span>
                    </span>
                  </div>
                  <div class="m-card-user__details">
                    <span class="m-card-user__name m--font-weight-500 m--font-light d-inline-block text-truncate mt-2"
                          style="max-width: 180px;">{{fullName}}</span>
                    <div class="clearfix"></div>
                    <span
                      class="m-card-user__email m--font-weight-300 m--font-light m-link d-inline-block text-truncate"
                      style="max-width: 180px;">{{email}}</span>
                  </div>
                </div>
              </div>
              <div class="m-dropdown__body">
                <div class="m-dropdown__content">
                  <ul class="m-nav m-nav--skin-light">

                     <li class="m-nav__item" v-if="isUserLogged">
                      <router-link :to="{ name: 'Dashboard'}" class="m-nav__link">
                        <i class="m-nav__link-icon flaticon-dashboard"></i>
                        <span class="m-nav__link-text">{{ $t('menus.main.overview') }}</span>
                      </router-link>
                    </li>

                    <li class="m-nav__separator m-nav__separator--dashed"  v-if="isUserLogged"></li>

                    <li class="m-nav__item">
                      <router-link :to="{ name: 'Logout'}" class="m-nav__link">
                        <i class="m-nav__link-icon flaticon-logout"></i>
                        <span class="m-nav__link-text">{{ $t("menus.user.logout")}}</span>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </li>
        <!-- begin: usermenu -->
      </ul>

    </div>
  </div>
</template>

<script>
  import Cookie from 'js-cookie'
  import functions from "@/plugins/functions"

  const flags = {
    es: process.env.CDN_URL+'/img/flags/spain.svg',
    en: process.env.CDN_URL+'/img/flags/uk.svg'
  };

  export default {
    name: 'top-bar',
    data() {
      return {
        cdn_url: process.env.CDN_URL,
        admin: {},
        user: {},
      }
    },
    mounted(){
      this.user = functions.getUser()
      this.admin = functions.getAdmin()
    },
    computed: {
      isUserLogged(){
        return Cookie.get('access_token');
      },
      firstLetter() {
        let admin = functions.getAdmin()
        if (admin && admin.Name && admin.Name.length > 0){
          return admin.Name[0]
        }
        return ''
      },
      email(){
        return this.admin ? this.admin.Email : ''
      },
      fullName(){
        return this.admin ? this.admin.Name : ''
      }
    }
  }


</script>



// WEBPACK FOOTER //
// src/components/dashboard/admin/common/menus/TopBar.vue